// Lightweight examination state - only stores IDs and essential data
export const examinationsObject = {
    // Examination metadata (lightweight) - null by default to avoid unnecessary re-renders
    currentExamination: null,

    // Current navigation state
    currentSectionIndex: 0,
    currentQuestionIndexInSection: 0,

    // Single question cache (load on demand)
    currentQuestion: null,
    questionCache: {}, // Cache for loaded questions: { questionId: questionData }

    // User progress
    userAnswers: {}, // { questionId: userAnswer }

    // Time tracking
    timeStatus: {
        totalTimeRemaining: 0, // milliseconds
        sectionTimeRemaining: 0, // milliseconds
        isTimeUp: false,
        lastUpdated: null
    },

    // Loading states
    isLoading: false,
    isCreating: false,
    isStarting: false,
    isSubmitting: false,
    isCompleting: false,
    isLoadingQuestion: false,

    // Error handling
    error: null,
    questionError: null
};